import { render, staticRenderFns } from "./sign-logistics-list.vue?vue&type=template&id=351c94de&"
import script from "./sign-logistics-list.vue?vue&type=script&lang=ts&"
export * from "./sign-logistics-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports